import { ArticleInfo, StaticArticleKey } from '@/types/article';
import { RedeemCodeInfo } from '@/types/coupon';
import fetch, { NewAxiosRequestConfig } from '@/utils/axios';

/**
 * @param params 获取文章静态key
 * @param config
 */
export const getStaticArticles = (
  params?: ObjectType,
  config?: NewAxiosRequestConfig
): Promise<AResponse<StaticArticleKey>> => {
  return fetch.get('/ec/growth/article/key/list', params, config);
};

/**
 * @param params 获取文章内容
 * @param config
 */
export const getArticleDetail = (key: string, config?: NewAxiosRequestConfig): Promise<AResponse<ArticleInfo>> => {
  return fetch.get(`/ec/growth/article/detail/${key}`, {}, config);
};

export const getEpDetail = (pageKey: string | string[], config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/ep/landing/${pageKey}`, {}, config);
};

export const getEpSuccess = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/ep/success`, params, config);
};

/**
 * @param params 获取砍单订单信息
 * @param config
 */
export const getOrderWeeebatesInfo = (params?: any, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth_v2/weeebates/new`, params, config);
};

/**
 * @param params 创建砍单
 * @param config
 */
export const createOrderWeeebates = (params?: any, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/growth_v2/weeebates`, params, config);
};

/**
 * @param params 分享砍单成功
 * @param config
 */
export const shareOrderWeeebates = (params?: any, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth_v2/weeebates/${params.id}/edit`, config);
};

/**
 * @param params 获取砍单landing页信息
 * @param config
 */
export const getOrderWeeebatesLanding = (params?: any, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth_v2/weeebates/receiver/new`, params, config);
};

export const getOrderWeeebatesLandingShare = (params?: any, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth_v2/weeebates/receiver/get_share_info`, params, config);
};

export const getOrderWeeebatesLandingBanner = (
  params?: {
    orderId: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/growth_v2/weeebates/receiver/get_landing_image`, params, config);
};

/**
 * @param params 获取砍单landing页信息
 * @param config
 */
export const getOrderWeeebatesFollow = (id, params?: any, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth_v2/weeebates/receiver/${id}`, params, config);
};

/**
 * @param params 获取砍单landing页信息
 * @param config
 */
export const orderShareClaim = (params?: any, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/growth_v2/weeebates/receiver`, params, config);
};

/** 砍单进度
 * @param orderId
 * @param config
 */
export const getShareProgress = (orderId: number, parames, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth_v2/weeebates/${orderId}`, parames || {}, config);
};

/** 砍单list
 * @param orderId
 * @param config
 */
export const getMyWeeebatesList = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth_v2/weeebates/list`, params || {}, config);
};

/** 砍单分享图片二维码
 * @param orderId
 * @param config
 */
export const getShareImgQrCode = (orderId: number, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth_v2/weeebates/api_qrcode?order_share_id=${orderId}`, {}, config);
};

/** 砍单弹出group提示
 * @param orderId
 * @param config
 */
export const joinGroupPopupShow = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth_v2/weeebates/record_more_popup`, params || {}, config);
};

/** 获取seo信息
 * @param params
 * @param config
 */
export const getSeoInfo = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/seo/meta`, params, config);
};

/**
 * 商品分享弹窗
 * @param params
 * @param config
 */
export const getProductShare = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/product`, params || {}, config);
};

/**
 * 品牌分享弹窗
 */
export const getBrandShare = (brandKey: string, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/growth/share/brand', { brand_key: brandKey }, config);
};

/**
 * @param params pdp分享弹窗生成图片
 * @param config
 */
export const getProductShareImageInfo = (id: number, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/share_image`, { product_id: id }, config);
};

/**
 * theme分享弹窗
 */
export const getThemeShare = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/growth/share/collection/theme', params, config);
};

/**
 * 砍单sign-up页面获取优惠券信息
 */
export const getCouponMessage = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/growth_v2/weeebates/receiver/fist_bargain_coupon_info', params, config);
};

/*
 * Ethnic landing page & Geo landing page
 * @param config
 * @returns
 */
export const getEthnicLandingProductList = (
  params?: ObjectType,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post(`/ec/growth/grocery/ethnic/storefront/info`, params, config);
};

/**
 * Grocery delivery page && all state
 * @param config
 * @returns
 */
export const getGroceryStateAll = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/seo/grocery/all`, params, config);
};

/**
 * Grocery delivery page && city
 * @param config
 * @returns
 */
export const getGroceryStateCity = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/seo/grocery/state/${params?.state_name}`, params, config);
};

/**
 * Grocery delivery page && product
 * @param config
 * @returns
 */
export const getGroceryCityProduct = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/seo/grocery/city`, params, config);
};

/*
 * 通用bar信息
 */
export const getCommonBarInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/growth/bar/info', params, config);
};
/*
 * 通用bar信息
 */
export const setCommonBarClose = (
  params: {
    bar_id: number;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post('/ec/growth/bar/user/close', params, config);
};

/*
 * vendor 首页分享信息
 */
export const getVendorShareInfo = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/vendor`, params, config);
};

/*
 * mkpl coupon landing 分享信息
 */
export const getMkplShareInfo = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/global_plus`, {}, config);
};

/**
 * top brand landing share
 * @param config
 * @returns
 */
export const getBrandLandingShare = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/collection/brand`, {}, config);
};

/**
 * 返利联盟
 * @param params
 * @param config
 * @returns
 */

export const getAffiliatePortal = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/growth/affiliate/dashboard', params, config);
};

export const getAffiliateBanner = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/banner/affiliate`, params, config);
};

export const getAffiliateStatement = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/growth/affiliate/statement', params, config);
};

export const getAffiliateDetail = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/growth/affiliate/detail', params, config);
};

export const getAffiliateReferral = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/affiliate/referral_portal`, params, config);
};

export const applyAffiliate = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/growth/affiliate/sign_up`, params, config);
};

export const getAffiliatelanding = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/affiliate/landing`, {}, config);
};

//判断是否是返利联盟
export const checkIsAffiliate = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/affiliate/info`, {}, config);
};

/**
 * hero landing share info
 * @param config
 * @returns
 */
export const getHeroLandingShareInfo = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/hero/landing`, params, config);
};

/**
 * 获取mkpl lightning deals share数据
 */
export const getMkplLightningShare = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/growth/share/mkpl/lighting', params, config);
};

/**
 * mkpl/bakery/landing share info
 * @param config
 * @returns
 */
export const getMkplBakeryLandingShareInfo = (
  params: ObjectType,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/bakery`, params, config);
};

/**
 * mkpl/bakery/landing share info
 * @param config
 * @returns
 */
export const getMkplFreshdeliLandingShareInfo = (
  params: ObjectType,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/freshdeli`, params, config);
};

/**
 * 获取freebie share
 * @param config
 * @returns
 */
export const getFreebieLandingShareInfo = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/freebies`, {}, config);
};

/**
 * mkpl group-order introducing share info
 * @param config
 * @returns
 */
export const getMkplGroupOrderIntroShareInfo = (
  params: ObjectType,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/introducing_group_order`, params, config);
};

/**
 * 首页获取 TopMessage 组件弹窗文案
 */
export const getMessageContent = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/message/get_safe_secure_tips`, {}, config);
};

/**
 * mkpl top items share info
 * @param config
 * @returns
 */
export const getMkplTopItemsShareInfo = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/top_items`, params, config);
};

/**
 * 获取raffle分享数据
 * @param params
 * @param config
 * @returns
 */
export const getRaffleShareData = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/disney/raffle`, params, config);
};

/**
 * 获取情人节raffle分享数据
 * @param params
 * @param config
 * @returns
 */
export const getRaffleShareInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/event/share/info`, params, config);
};

export const getCampaignsShareInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/info`, params, config);
};

/**
 * sku level coupon product list page share info
 * @param config
 * @returns
 */
export const getCouponProductsPageShareInfo = (
  params: {
    plan_id: number | string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/level_coupon`, params, config);
};

/**
 * get referral page
 * @param params
 * @param config
 * @returns
 */
export const getReferralPage = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/invite/share/v1`, params, config);
};

/**
 * get referral info
 * @param params
 * @param config
 * @returns
 */

export const getReferralInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/invite/get_referral_title`, params, config);
};

/**
 * get referral share image data
 * @param params
 * @param config
 * @returns
 */

export const getShareReferralImage = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/invite/share_image`, params, config);
};

/**
 * referral success page
 * @param params
 * @param config
 * @returns
 */

export const getReferralSuccessPage = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/invite/success/v1`, params, config);
};

export const getReferralLandingData = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/invite/landing/v1`, params, config);
};

/**
 *  如果是普通用户，被邀请人访问的时侯并登录时保存他们之间的关系
 * @param invitor_id 分享者id
 * @param config
 */
export const createInviteRelation = (invitor_id: string, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch
    .get<AResponse, AResponse>(
      '/ec/growth/invite/create_invite',
      {
        invitor_id
      },
      config
    )
    .then(res => {
      return res;
    });
};

export const getFreeGiftShareInfo = (
  params: {
    psId: number | string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/promo_landing`, params, config);
};

/**
/* 提升问卷信息
 * @param data 请求参数
 * @returns 返回值
 */
export const getImprovementSurveyInfo = (
  data: {
    user_id?: string;
    group: 'a' | 'b' | string;
    survey_id?: string;
    ref_type?: string;
    ref_id?: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/growth/survey/get/survey', data, config);
};

/**
 * 提交答案
 * @param data 参数
 * @returns 返回数据
 */
export const setImprovementSurveyAnswer = (data: {
  task_id: string | number;
  user_id?: string;
  status: 'F' | 'P' | 'Q' | 'E'; //用户完成答卷状态 F：用户点击send to weee；P：用户完成了NPS部分；Q：没有回答任意问题;E:回答部分附加题 没有提交
  ref_type: 'account_page' | 'order_confirm' | 'home_page' | 'order_list' | 'order_detail'; //用户在什么页面回答的(me order_confirm)
  answer?: {
    [key: string]: {
      rating?: string;
      option_ids?: string;
      comment?: string;
    };
  };
}): Promise<AResponse> => {
  return fetch.post('/ec/growth/survey/submit/answer ', data);
};

/**
 * 获取rewards wednesday活动信息
 * @param params
 * @param config
 * @returns
 */
export const fetchRewardsData = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/account/rewards/promotion`, params, config);
};
/**
 * 获取rewards wednesday分享信息
 * @param params
 * @param config
 * @returns
 */
export const fetchRewardsShareInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/account/rewards/promotion/share`, params, config);
};

/**
 * 手机验证成功获取coupon信息
 * @param params
 * @param config
 * @returns
 */
export const getPhoneVerifiedCouponInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/event/activity/center/user/coupon`, params, config);
};

/**
 * 获取RFM Coupon信息
 * @param params
 * @param config
 */
export const getRfmCouponInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/event/activity/center/coupon/info`, params, config);
};

/**
 * points 活动信息
 */
export const getPointExclusive = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/growth/event/activity/center/points', params, config);
};

/**
 * 获取student discount页面产品数据
 * @param params
 * @param config
 * @returns
 */
export const getStudentDiscountProductList = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/product/student_activity_products`, {}, config);
};

export const getCategoryTopBanner = (params?: ObjectType, config?: NewAxiosRequestConfig) => {
  return fetch.get(`/ec/growth/banner/get_category_banner/v2`, params, config);
};
/**
 * 获取related topics on footer数据
 * @param params
 * @param config
 * @returns
 */
export const getRelatedTopicsOnFooter = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/seo/footer/related_topics`, params, config);
};

/**
 * 根据zipcode查询city, state信息
 * @param config
 * @returns
 */
export const getDeliveryStateCity = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/address/zipcode_area`, params, config);
};

/**
 * 年终报告信息
 * @param config
 * @returns
 */
export const getAnnualReport = (
  params: {
    userId: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/growth/user_recap/anniversary/detail/query`, params, config);
};
/**
 * 年终报告分享
 * @param config
 * @returns
 */
export const getAnnualReportShare = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/anniversary`, {}, config);
};

/**
 * 获取活动信息
 * @param params
 * @param config
 * @returns
 */
export const fetchExternalCampaignData = (
  params: {
    key: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/info`, params, config);
};

/**
 * account coupon 兑换优惠券
 * @param params
 * @param config
 * @returns
 */
export const redeemCoupon = (
  params: {
    redeem_code?: string;
    action?: string;
    record_id?: number;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse<RedeemCodeInfo>> => {
  return fetch.post(`/ec/growth/rewards/code/redeem`, params, config);
};

export const getBackStockProduct = (params: any, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/backstock/user/product/get`, params, config);
};

export const getRewardsLandingData = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/account/rewards/wednesday/landing_page`, params, config);
};

export const getAccountCouponV2 = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/growth/user/benefit/query`, params, config);
};
